<div
	id="showMoreLinkListWrapperEl"
	class="c-show-more-link-list {{addClass || ''}}"
	style="height: {{wrapperHeight}}"
>
	<div class="c-show-more-link-list_inner">
		{{#each limitedList as item}}
			<a href="{{@this.makeURLFromASN(item)}}" class="c-show-more-link-list_inner_item">{{prefix || ''}}{{item}}</a>
		{{/each}}

		{{#if list.length > limit}}
			<button
				class="c-show-more-link-list_toggle-button"
				on-click="@this.set('expanded', !expanded)"
			>
				{{expanded ? 'Show less' : 'Show more'}}
			</button>
		{{/if}}
	</div>
</div>

<script>
	const listeners = require('../../assets/js/utils/listeners');
	const ITEMS_TO_SHOW_LIMIT = 4;

	component.exports = {
		data () {
			return {
				wrapperHeight: 'auto',
				expanded: false,
				limitedList: null,
				initialHeight: null,
				restList: [],
				limit: ITEMS_TO_SHOW_LIMIT,
			};
		},
		onrender () {
			if (!Ractive.isServer) {
				listeners.addManagedListener(this, window, 'resize', this.handleResize.bind(this));

				let wrapperEl = this.find('#showMoreLinkListWrapperEl');

				this.observe('expanded', (expanded) => {
					let list = this.get('list') || [];
					let limit = this.get('limit');

					this.set('limitedList', expanded ? list : list.slice(0, limit));

					if (expanded) {
						requestAnimationFrame(() => {
							this.set('wrapperHeight', `${wrapperEl.scrollHeight}px`);
						});
					} else {
						this.set('wrapperHeight', `${wrapperEl.scrollHeight}px`);

						requestAnimationFrame(() => {
							this.set('wrapperHeight', this.get('initialHeight'));
						});
					}
				});

				this.observe('limitedList', (limitedList) => {
					let initialHeight = this.get('initialHeight');

					if (initialHeight === null && limitedList && limitedList.length) {
						requestAnimationFrame(() => {
							let height = `${wrapperEl.scrollHeight}px`;

							this.set('initialHeight', height);
							this.set('wrapperHeight', height);
						});
					}
				});
			}
		},
		handleResize () {
			let wrapperEl = this.find('#showMoreLinkListWrapperEl');
			let expanded = this.get('expanded');

			if (expanded) {
				this.set('wrapperHeight', `${wrapperEl.scrollHeight}px`);
				this.set('expanded', false);

				requestAnimationFrame(() => {
					this.set('wrapperHeight', 'auto');
				});
			}

			requestAnimationFrame(() => {
				let height = `${wrapperEl.scrollHeight}px`;

				this.set('initialHeight', height);
				this.set('wrapperHeight', height);
			});
		},
		makeURLFromASN (id) {
			let method = this.get('method')?.toLowerCase() || 'ping';
			let prefix = this.get('prefix') ?? '';

			return `/network-tools/${method}-from-${prefix}${id}`;
		},
	};
</script>
